// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"00b98eb8","154":"f43a72e6","312":"edf292bb","430":"c62179d3","646":"9ef8958c","979":"e01a260c"}[chunkId] + ".chunk.js";
};